(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eg-roller-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const tolerance = 1;

    const replaceTokens = (text, tokens) => {
      let output = text;
      Object.entries(tokens).forEach(([key, value]) => {
        output = output.replaceAll(`[[${key}]]`, value);
      });
      return output;
    };

    const formatNumber = value => String(value).replace('.', ',');

    const createTextElement = (tagName, className, text) => {
      const element = document.createElement(tagName);
      element.className = className;
      element.textContent = text;
      return element;
    };

    const getAvailableSizes = () => {
      const values = new Set();

      document.querySelectorAll('input[type="radio"][name^="options["]').forEach(input => {
        const value = (input.value || '').trim();
        const match = value.match(/^(\d+)\s*[x×]/i) || value.match(/^(\d+)/);
        if (match?.[1]) values.add(Number.parseInt(match[1], 10));
      });

      document.querySelectorAll('select[name^="options["] option').forEach(option => {
        const value = (option.value || option.textContent || '').trim();
        const match = value.match(/^(\d+)\s*[x×]/i) || value.match(/^(\d+)/);
        if (match?.[1]) values.add(Number.parseInt(match[1], 10));
      });

      if (values.size === 0) {
        document.querySelectorAll('[data-option-value], .product-form__input label').forEach(option => {
          const value = (option.getAttribute('data-option-value') || option.textContent || '').trim();
          const match = value.match(/^(\d+)\s*[x×]/i) || value.match(/^(\d+)/);
          if (match?.[1]) values.add(Number.parseInt(match[1], 10));
        });
      }

      return Array.from(values).sort((a, b) => a - b);
    };

    const selectVariantSize = size => {
      const selects = Array.from(document.querySelectorAll('select[name^="options["]'));
      const select = selects.find(candidate => Array.from(candidate.options).some(option => {
        const value = (option.value || option.textContent || '').trim();
        return value.startsWith(`${size}x`) || value.startsWith(`${size}×`) || value === String(size);
      }));

      if (select) {
        const option = Array.from(select.options).find(candidate => {
          const value = (candidate.value || candidate.textContent || '').trim();
          return value.startsWith(`${size}x`) || value.startsWith(`${size}×`) || value === String(size);
        });
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }

      const radios = Array.from(document.querySelectorAll('input[type="radio"][name^="options["]'));
      const target = radios.find(radio => {
        const value = (radio.value || '').trim();
        return value.startsWith(`${size}x`) || value.startsWith(`${size}×`) || value === String(size);
      });

      if (target) {
        const label = target.id ? document.querySelector(`label[for="${CSS.escape(target.id)}"]`) : null;
        (label || target).click();
        return true;
      }

      const labels = Array.from(document.querySelectorAll('.product-form__input label'));
      const fallback = labels.find(label => {
        const value = (label.textContent || '').trim();
        return value.startsWith(`${size}x`) || value.startsWith(`${size}×`) || value === String(size);
      });

      if (fallback) {
        fallback.click();
        return true;
      }

      return false;
    };

    const init = root => {
      if (root.dataset.mounted === 'true') return;
      root.dataset.mounted = 'true';

      const input = root.querySelector('.eg-size-guide__input');
      const calculate = root.querySelector('.eg-size-guide__calculate');
      const result = root.querySelector('.eg-size-guide__result');

      const resetRecommendation = () => {
        root.dataset.extenderPacks = '0';
        root.dataset.recommendedSize = '';
      };

      const showMessage = message => {
        resetRecommendation();
        result.replaceChildren(createTextElement('p', 'eg-size-guide__message', message));
      };

      const showStandard = (size, extenderPacks = 0) => {
        const wrap = document.createElement('div');
        wrap.className = 'eg-size-guide__standard';

        const title = createTextElement(
          'p',
          'eg-size-guide__result-title',
          replaceTokens(root.dataset.standardTitle, { size: formatNumber(size) })
        );
        const rangeText = extenderPacks === 1
          ? root.dataset.extenderCopyOne
          : extenderPacks === 2
            ? root.dataset.extenderCopyTwo
            : replaceTokens(root.dataset.standardRange, {
                min: formatNumber(size - tolerance),
                max: formatNumber(size + tolerance)
              });
        const range = createTextElement('p', 'eg-size-guide__result-copy', rangeText);
        if (extenderPacks > 0) {
          range.append(createTextElement('span', 'eg-size-guide__extender-note', root.dataset.extenderNote));
        }

        const chooseText = extenderPacks === 1
          ? root.dataset.chooseExtenderOne
          : extenderPacks === 2
            ? root.dataset.chooseExtenderTwo
            : root.dataset.chooseSize;
        const button = createTextElement(
          'button',
          'eg-size-guide__choice',
          replaceTokens(chooseText, { size: formatNumber(size) })
        );
        button.type = 'button';
        button.addEventListener('click', () => {
          root.dataset.recommendedSize = String(size);
          root.dataset.extenderPacks = String(extenderPacks);
          if (selectVariantSize(size)) {
            const selectedText = extenderPacks === 1
              ? root.dataset.selectedExtenderOne
              : extenderPacks === 2
                ? root.dataset.selectedExtenderTwo
                : root.dataset.selected;
            button.textContent = replaceTokens(selectedText, { size: formatNumber(size) });
            button.disabled = true;
          } else {
            showMessage(root.dataset.selectionError);
          }
        });

        wrap.append(title, range, button);
        result.replaceChildren(wrap);
      };

      const showSpecial = () => {
        resetRecommendation();
        const wrap = document.createElement('div');
        wrap.className = 'eg-size-guide__special';

        const title = createTextElement('p', 'eg-size-guide__result-title', root.dataset.specialTitle);
        const copy = createTextElement('p', 'eg-size-guide__result-copy', root.dataset.specialBody);
        const link = createTextElement('a', 'eg-size-guide__special-cta', root.dataset.specialCta);
        link.href = '/products/rullegardin-uden-boring-specialmal';

        wrap.append(title, copy, link);
        result.replaceChildren(wrap);
      };

      const render = () => {
        const normalized = input.value.trim().replace(',', '.');
        const width = Number(normalized);

        if (!normalized || !Number.isFinite(width) || width <= 0) {
          showMessage(root.dataset.invalid);
          return;
        }

        const sizes = getAvailableSizes();
        if (sizes.length === 0) {
          showMessage(root.dataset.noSizes);
          return;
        }

        const standardSize = sizes.find(candidate => width >= candidate - tolerance && width <= candidate + tolerance);
        if (standardSize) {
          showStandard(standardSize);
          return;
        }

        const extenderSize = sizes.find(candidate => {
          const standardMaximum = candidate + tolerance;
          return width > standardMaximum && width <= standardMaximum + 2;
        });

        if (extenderSize && root.dataset.extenderAvailable === 'true') {
          const extenderPacks = Math.ceil(width - (extenderSize + tolerance));
          showStandard(extenderSize, Math.min(extenderPacks, 2));
          return;
        }

        showSpecial();
      };

      calculate.addEventListener('click', render);
      input.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          render();
        }
      });
      input.addEventListener('input', () => {
        resetRecommendation();
        if (result.childElementCount > 0) result.replaceChildren();
      });

      document.addEventListener('change', event => {
        if (!root.dataset.recommendedSize || !event.target.matches('input[type="radio"], select[name^="options["]')) return;
        const match = String(event.target.value || '').trim().match(/^(\d+)\s*[x×]/i);
        if (!match?.[1]) return;
        if (Number(match[1]) !== Number(root.dataset.recommendedSize)) {
          showMessage(root.dataset.sizeChanged);
        }
      });
    };

    const initAll = root => {
      root.querySelectorAll('.eg-size-guide').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', event => initAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
